import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { DocusignIcon, DocusignIconBorderless, DocusignSearchResultIcon } from './icon';

export const docusignConfig: ThirdPartyConfig = {
	displayName: 'Docusign',
	id: 'docusign',
	resourceType: ProductResourceTypes3P.Docusign,
	icon: get3PLogo(DocusignIcon, 'Docusign', 'medium'),
	iconBorderless: get3PLogo(DocusignIconBorderless, 'Docusign', 'small'),
	searchResultIcon: get3PLogo(DocusignSearchResultIcon, 'Docusign', 'large'),
	integrationAri: 'ari:cloud:platform::integration/docusign',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
